import React, { Component } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faGraduationCap, faArrowLeft, faBars, faBookOpen, faUser, faSignOutAlt, faHouseUser, faPen, faPaperPlane, faFile } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from "react-router";
import { useHistory } from "react-router";
import './SidePanel.css';
import { faTeamspeak } from '@fortawesome/free-brands-svg-icons';

function SidePanel({ collapsed, setCollapsed }) {
  // const history = useHistory();
  // const { collapseSidebar } = useProSidebar();
  const history = useHistory();

  const handleLogout = () => {
    sessionStorage.removeItem("userData")
    history.push("/")
  }

  return (
    // <div style={{ display: 'flex', height: '100%' }} className="side-panel-wrapper">
    //   <Sidebar>
    //     <button onClick={() => collapseSidebar()} className="btn  fr">
    //         <FontAwesomeIcon icon={faBars} />
    //     </button>
    //     <Menu>
    //       <MenuItem onClick={()=> history.push("/org-admin/overview")} icon={<FontAwesomeIcon icon={faHouseUser} />} > Home</MenuItem>
    //       <MenuItem onClick={()=> history.push("/org-admin/project")} icon={<FontAwesomeIcon icon={faBullhorn} />}> Projects</MenuItem>
    //       <MenuItem onClick={()=> history.push("/org-admin/level")} icon={<FontAwesomeIcon icon={faUser} />}> Level</MenuItem>
    //       <MenuItem onClick={()=> history.push("/org-admin/department")} icon={<FontAwesomeIcon icon={faTeamspeak} />}> Department</MenuItem>
    //       <MenuItem onClick={()=> history.push("/org-admin/admin")} icon={<FontAwesomeIcon icon={faUser} />}> Admins</MenuItem>
    //       <MenuItem onClick={()=> history.push("/login")} icon={<FontAwesomeIcon icon={faSignOutAlt} />}> Logout</MenuItem>
    //     </Menu>
    //   </Sidebar>

    // </div>
    <div style={{ display: 'flex', height: '100%' }} className="admin-side-panel-wrapper">
      <Sidebar
      collapsed={collapsed}
        backgroundColor='rgba(29, 41, 61, 0.95)'
      >
        <button onClick={() => setCollapsed(!collapsed)} className="btn toggle-btn sb-button">
          <FontAwesomeIcon icon={faBars} />
        </button>
        <Menu>
          <MenuItem onClick={() => history.push("/org-admin/overview")} icon={<FontAwesomeIcon icon={faHouseUser} />} > Home</MenuItem>
          <MenuItem onClick={() => history.push("/org-admin/project")} icon={<FontAwesomeIcon icon={faBullhorn} />}> Projects</MenuItem>
          <MenuItem onClick={() => history.push("/org-admin/level")} icon={<FontAwesomeIcon icon={faUser} />}> Level</MenuItem>
          <MenuItem onClick={() => history.push("/org-admin/department")} icon={<FontAwesomeIcon icon={faTeamspeak} />}> Department</MenuItem>
          <MenuItem onClick={() => history.push("/org-admin/admin")} icon={<FontAwesomeIcon icon={faUser} />}> Admins</MenuItem>
          <MenuItem onClick={handleLogout} icon={<FontAwesomeIcon icon={faSignOutAlt} />}> Logout</MenuItem>
        </Menu>
      </Sidebar>

    </div>
  );
}

export default withRouter(SidePanel);